import React from "react";
import {observer} from "mobx-react";
import {Space} from "antd";
import {callAndReload} from "../utils";
import PopupMenu from "./PopupMenu";
import Device from "./Device";
import User from "@/components/User.js";

let DemoControl = observer(({}) => {
  // Check if demo controls should be available:
  // - For test tournaments (gon.test = true)
  // - For local development with admin user (user id 1)
  if ((!Device.local) || !User.admin)
    return null;

  let onClick = a => {
    callAndReload({
      url: "/demos/1",
      method: 'get',
      params: { demo_action: a, tid: gon.tournament.tid }
    })
  }

  return <Space>
    <PopupMenu actions={[
      ["Check In All", "checkinall"],
      ["Fill All Scores", "fill_scores"],
      ["Reset", "reset"],
    ]} text="Test Control" onClick={onClick}/>
  </Space>
});

export default DemoControl;